import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import OkCancelModal from '@/shared/components/OkCancelModal';
import ToastrService from '@/shared/services/ToastrService';
import { useChangeCommunicationEmail } from '@/shared/hooks/profile/useChangeCommunicationEmail';
import adminpulse from '@/shared/utils/adminpulse';
import messages from '../profileMessages';
const ChangeCommunicationEmailModal = ({ show, onClose, currentEmail, }) => {
    const intl = useIntl();
    const { changeCommunicationEmail } = useChangeCommunicationEmail();
    const [email, setEmail] = useState('');
    const [dirty, setDirty] = useState(false);
    const trimmedEmail = email.trim();
    const isValid = adminpulse.isValidEmail(trimmedEmail);
    const isSameAsCurrent = !!currentEmail && trimmedEmail.toLowerCase() === currentEmail.toLowerCase();
    const formValid = isValid && !isSameAsCurrent;
    const handleClose = () => {
        setEmail('');
        setDirty(false);
        onClose();
    };
    const handleSave = async () => {
        try {
            await changeCommunicationEmail({ newEmail: trimmedEmail });
            ToastrService.success(intl.formatMessage(messages.CommunicationEmailChangeSent));
            handleClose();
        }
        catch (_a) {
            // error toastr already shown by hook
        }
    };
    return (_jsx(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.ChangeCommunicationEmail), show: show, onSave: handleSave, onClose: handleClose, disabled: !formValid, okLabel: intl.formatMessage(messages.SendEmail) }, { children: _jsxs("div", Object.assign({ className: "form-horizontal" }, { children: [_jsx("div", Object.assign({ role: "alert", className: "alert alert-info" }, { children: _jsx("div", { children: intl.formatMessage(messages.ChangeCommunicationEmailInfo) }) })), _jsxs("div", Object.assign({ className: classNames('form-group', {
                        'has-error': dirty && !formValid,
                    }) }, { children: [_jsx("label", Object.assign({ className: "control-label col-md-4" }, { children: intl.formatMessage(messages.NewCommunicationEmail) })), _jsxs("div", Object.assign({ className: "col-md-8" }, { children: [_jsx("input", { type: "email", className: "form-control", value: email, onChange: e => {
                                        setEmail(e.target.value);
                                        setDirty(true);
                                    } }), dirty && !email && (_jsx("ul", Object.assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }) }))), dirty && email && !isValid && (_jsx("ul", Object.assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.InvalidEmailAddress) }) })))] }))] }))] })) })));
};
export default ChangeCommunicationEmailModal;
